import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

import { PhoneNumber } from './PhoneNumber/index.tsx';
import { RecoveryEmail } from './RecoveryEmail/index.tsx';
import { TwoFA } from './TwoFA/index.tsx';

const Content = styled(Vertical).attrs({ gap: 2 })`
  padding: var(--triple-unit);
`;

const Blocks = styled.div`
  border: solid 1px var(--c-nd-200);
  border-radius: var(--double-unit);
`;

const Block = styled.div`
  padding: var(--double-unit);
  &:not(:last-child) {
    border-bottom: solid 1px var(--c-nd-200);
  }
`;

type Props = {
  onClose: () => void;
};
export const Home = ({ onClose }: Props) => {
  return (
    <Content>
      <Blocks>
        <Block>
          <RecoveryEmail />
        </Block>
        <Block>
          <PhoneNumber />
        </Block>
        <Block>
          <TwoFA />
        </Block>
      </Blocks>
      <Button size="medium" onClick={onClose} color="destructive">
        <FormattedMessage {...glossary.skip} />
      </Button>
    </Content>
  );
};
